var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-row',{staticClass:"ma-2"},_vm._l((_vm.cars),function(car){return _c('v-col',{key:car.name,staticClass:"mx-auto"},[_c('itemcard',{attrs:{"car":car}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }